import { VvdFilter } from "./VvdFilter";

export default function Verkehrsvertragsdaten({vvdInstance, vvInstance, statusInstance, zvInstance}) {
    return (
        <div>
            <h1>Verkehrsvertragsdaten</h1>
            <VvdFilter vvInstance={vvInstance} statusInstance={statusInstance} zvInstance={zvInstance} vvdInstance={vvdInstance}/>
        </div>
    )
}